const initialStateFilters = {
  ciclo: {id: 1, name: 'Janeiro'},
  compararCiclos: {id: 'ativar', name: 'Ativar'},
  dataInicial: null,
  dataFinal: null
}
const initialStatePaginate = { 
  pageNumber: 1, 
  totalPages: 1, 
  totalElements: 0,
  perPage: 7
}

const initialState = {
  totalAvaliacao: 0,
  projetos: [],
  dadosProjeto: [],
  paginate: initialStatePaginate,
  projeto: {},
  filtersProvisorio: initialStateFilters,
  loadList: false,
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case 'LIST_PROJETOS':
      return { ...state, projetos: payload}
    case 'DADOS_PROJETO_TOTAL_AVALIACAO':
      return { ...state, totalAvaliacao: payload}
    case 'LIST_DADOS_PROJETO':
      return { ...state, dadosProjeto: payload}
    case 'PAGINATE_DADOS_PROJETO':
      return { ...state, paginate: {...initialState.paginate, ...payload}}
    case 'INFO_PROJETO':
      return { ...state, projeto: payload}
    case 'INFO_FILTERS_DADOS_PROJETO':
      return { ...state, filtersProvisorio: payload}
    case 'CHANGE_FILTERS_DADOS_PROJETO':
      return { ...state, filtersProvisorio: {...state.filtersProvisorio, [payload.name]: payload.value}}
    case 'CLEAN_FILTERS_DADOS_PROJETO':
      return { ...state, filtersProvisorio: initialStateFilters}
    case 'LOAD_LIST_DADOS_PROJETO':
      return { ...state, loadList: payload}

    default:
      return state
  }
}